// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Card,
//   CardContent,
//   Button,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   IconButton,
//   Divider,
//   ButtonBase,
//   Tooltip,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   ChevronRight as ChevronRightIcon,
//   Folder as FolderIcon,
//   Edit as EditIcon,
// } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
// import { getUserProfile } from "../../utils/auth";
// import {
//   fetchAdminStats,
//   fetchActiveStudies,
//   fetchPatientData,
//   fetchEnrollmentStats,
//   fetchBiospecimenStats,
//   fetchConsentStats,
//   fetchConsentFormGroups,
//   fetchStudies,
// } from "../../utils/api";
// import "styles/Dashboard.css";
// import PageHeader from "../../components/PageHeader";
// import { ADMIN_ROUTES } from "../../constants/routes";
// import FollowUpTypeManagementCard from "./components/FollowUpTypeManagementCard";
// import KitTypeManagementCard from "./components/KitTypeManagementCard";
// import SampleTypeManagementCard from "./components/SampleTypeManagementCard";
// import AddEditStudy from "./AddEditStudy";

// const maroon = "#500000";

// // Active Studies Card Component
// const ActiveStudiesCard = ({
//   studies,
//   totalPatients,
//   onAddStudy,
//   onViewStudyPatients,
//   onEditStudy,
// }) => {
//   return (
//     <Card
//       elevation={1}
//       sx={{
//         height: "100%",
//         boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
//         borderRadius: 0,
//       }}
//     >
//       <CardContent
//         sx={{
//           height: "100%",
//           display: "flex",
//           flexDirection: "column",
//           pb: "14px !important",
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "flex-start",
//             mb: 2,
//           }}
//         >
//           <Typography variant="h6" sx={{ fontWeight: 700, color: maroon }}>
//             Active Studies
//           </Typography>
//           <Button
//             variant="text"
//             startIcon={<AddIcon />}
//             onClick={onAddStudy}
//             sx={{
//               color: "#666",
//               fontWeight: 600,
//               fontSize: "0.75rem",
//               py: 0.5,
//               px: 1.5,
//               "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)", color: "#333" },
//             }}
//           >
//             ADD STUDY
//           </Button>
//         </Box>
//         <Divider sx={{ mb: 2 }} />
//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns: { xs: "1fr", md: "280px minmax(0, 1fr)" },
//             gap: 3,
//             alignItems: "stretch",
//           }}
//         >
//           <Box
//             sx={{
//               px: 2,
//               py: 1,
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "flex-start",
//               alignItems: "center",
//               gap: 2,
//               minHeight: 84,
//               textAlign: "center",
//             }}
//           >
//             <Typography
//               variant="caption"
//               sx={{ color: maroon, fontWeight: 700, fontSize: "0.8rem" }}
//             >
//               TOTAL PATIENTS ENROLLED
//             </Typography>
//             <Typography variant="h3" sx={{ color: maroon, fontWeight: 700 }}>
//               {totalPatients ?? 0}
//             </Typography>
//           </Box>
//           <Box sx={{ minWidth: 0, pr: { xs: 0, md: 4 } }}>
//             <Box
//               sx={{
//                 display: "grid",
//                 gridTemplateColumns: "minmax(0, 1fr) 120px 96px",
//                 gap: 2,
//                 pb: 1,
//               }}
//             >
//               <Typography
//                 variant="caption"
//                 sx={{ color: "#666", fontWeight: 700 }}
//               >
//                 STUDY
//               </Typography>
//               <Typography
//                 variant="caption"
//                 sx={{ color: "#666", fontWeight: 700, textAlign: "right" }}
//               >
//                 ENROLLED
//               </Typography>
//               <Typography
//                 variant="caption"
//                 sx={{ color: "#666", fontWeight: 700, textAlign: "right" }}
//               >
//                 ACTION
//               </Typography>
//             </Box>
//             <List sx={{ py: 0 }}>
//               {studies.map((study, index) => (
//                 <ListItem
//                   key={study.irbStudy || index}
//                   sx={{
//                     px: 0,
//                     py: 0.75,
//                     display: "grid",
//                     gridTemplateColumns: "minmax(0, 1fr) 120px 96px",
//                     gap: 2,
//                     borderTop: index === 0 ? "1px solid #eee" : 0,
//                     borderBottom:
//                       index === studies.length - 1 ? 0 : "1px solid #eee",
//                   }}
//                 >
//                   <Box
//                     sx={{ display: "flex", alignItems: "center", minWidth: 0 }}
//                   >
//                     <ListItemIcon sx={{ minWidth: 20 }}>
//                       <Box
//                         sx={{
//                           width: 12,
//                           height: 12,
//                           borderRadius: "50%",
//                           backgroundColor: "#4caf50",
//                           border: "2px solid #4caf50",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <Box
//                           sx={{
//                             width: 6,
//                             height: 6,
//                             borderRadius: "50%",
//                             backgroundColor: "white",
//                           }}
//                         />
//                       </Box>
//                     </ListItemIcon>
//                     <ListItemText
//                       primary={study.name}
//                       primaryTypographyProps={{
//                         fontSize: "0.9rem",
//                         fontWeight: 500,
//                         noWrap: true,
//                       }}
//                     />
//                   </Box>
//                   <ButtonBase
//                     onClick={() => onViewStudyPatients(study.irbStudy)}
//                     disabled={!study.irbStudy}
//                     aria-label={`View participants enrolled for ${study.name}`}
//                     sx={{
//                       justifySelf: "end",
//                       color: maroon,
//                       fontWeight: 700,
//                       fontSize: "1rem",
//                       px: 1,
//                       py: 0.25,
//                       minWidth: 56,
//                       display: "inline-flex",
//                       alignItems: "center",
//                       justifyContent: "flex-end",
//                       gap: 0.25,
//                       "&:hover": {
//                         textDecoration: "underline",
//                       },
//                       "&.Mui-disabled": {
//                         color: "#999",
//                       },
//                     }}
//                   >
//                     {study.patientCount ?? 0}
//                     <ChevronRightIcon sx={{ fontSize: 18 }} />
//                   </ButtonBase>
//                   <Tooltip title="Edit">
//                     <IconButton
//                       size="small"
//                       onClick={() => onEditStudy(study)}
//                       sx={{ justifySelf: "end", color: maroon }}
//                     >
//                       <EditIcon fontSize="small" />
//                     </IconButton>
//                   </Tooltip>
//                 </ListItem>
//               ))}
//             </List>
//           </Box>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// // BioSpecimen Samples Card Component
// const BioSpecimenSamplesCard = ({ stats, onViewSamples }) => {
//   return (
//     <Card
//       elevation={1}
//       sx={{
//         height: "100%",
//         boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
//         borderRadius: 0,
//       }}
//     >
//       <CardContent
//         sx={{
//           height: "100%",
//           display: "flex",
//           flexDirection: "column",
//           pb: "10px !important",
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "flex-start",
//             mb: 2,
//           }}
//         >
//           <Typography variant="h6" sx={{ fontWeight: 700, color: maroon }}>
//             BioSpecimen Samples
//           </Typography>
//           <Button
//             variant="text"
//             endIcon={<ChevronRightIcon />}
//             onClick={onViewSamples}
//             sx={{
//               color: "#666",
//               fontWeight: 600,
//               fontSize: "0.75rem",
//               py: 0.5,
//               px: 1.5,
//               "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)", color: "#333" },
//             }}
//           >
//             VIEW SAMPLE DATA
//           </Button>
//         </Box>
//         <Divider />
//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns: {
//               xs: "1fr",
//               sm: "repeat(3, minmax(0, 1fr))",
//             },
//             gap: 2,
//             flexGrow: 1,
//             alignItems: "center",
//             py: 2,
//           }}
//         >
//           <Box sx={{ textAlign: "center", m: 1 }}>
//             <Typography
//               variant="caption"
//               sx={{ color: maroon, fontWeight: 600, fontSize: "0.8rem" }}
//             >
//               TOTAL SAMPLES COLLECTED
//             </Typography>
//             <Typography
//               variant="h4"
//               sx={{ color: maroon, fontWeight: 700, mt: 0.5 }}
//             >
//               {stats.totalSamplesCollected}
//             </Typography>
//           </Box>
//           <Box sx={{ textAlign: "center", m: 1 }}>
//             <Typography
//               variant="caption"
//               sx={{ color: maroon, fontWeight: 600, fontSize: "0.8rem" }}
//             >
//               TOTAL ALIQUOTS PROCESSED
//             </Typography>
//             <Typography
//               variant="h4"
//               sx={{ color: maroon, fontWeight: 700, mt: 0.5 }}
//             >
//               {stats.totalAliquotsProcessed}
//             </Typography>
//           </Box>
//           <Box sx={{ textAlign: "center", m: 1 }}>
//             <Typography
//               variant="caption"
//               sx={{ color: maroon, fontWeight: 600, fontSize: "0.8rem" }}
//             >
//               TOTAL ALIQUOTS SHIPPED
//             </Typography>
//             <Typography
//               variant="h4"
//               sx={{ color: maroon, fontWeight: 700, mt: 0.5 }}
//             >
//               {stats.totalAliquotsShipped}
//             </Typography>
//           </Box>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// // Consent Management Card Component
// const ConsentManagementCard = ({ stats, onOutstandingReviews }) => {
//   return (
//     <Card
//       elevation={1}
//       sx={{
//         height: "100%",
//         boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
//         borderRadius: 0,
//       }}
//     >
//       <CardContent
//         sx={{ height: "100%", display: "flex", flexDirection: "column" }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "flex-start",
//             mb: 2,
//           }}
//         >
//           <Typography variant="h6" sx={{ fontWeight: 700, color: maroon }}>
//             Consent Management
//           </Typography>
//           <Button
//             variant="text"
//             endIcon={<ChevronRightIcon />}
//             onClick={onOutstandingReviews}
//             sx={{
//               color: "#666",
//               fontWeight: 600,
//               fontSize: "0.75rem",
//               py: 0.5,
//               px: 1.5,
//               "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)", color: "#333" },
//             }}
//           >
//             OUTSTANDING REVIEWS
//           </Button>
//         </Box>
//         <Divider sx={{ mb: 2 }} />

//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-around",
//             alignItems: "center",
//             flexGrow: 1,
//           }}
//         >
//           <Box sx={{ textAlign: "center" }}>
//             <Typography
//               variant="caption"
//               sx={{ color: maroon, fontWeight: 600, fontSize: "0.8rem" }}
//             >
//               REVIEWS NEEDED
//             </Typography>
//             <Typography
//               variant="h4"
//               sx={{ color: "#d32f2f", fontWeight: 700, mt: 0.5 }}
//             >
//               {stats.reviewsNeeded}
//             </Typography>
//           </Box>

//           <Box sx={{ textAlign: "center" }}>
//             <Typography
//               variant="caption"
//               sx={{ color: maroon, fontWeight: 600, fontSize: "0.8rem" }}
//             >
//               EXPIRED CONSENTS
//             </Typography>
//             <Typography
//               variant="h4"
//               sx={{ color: maroon, fontWeight: 700, mt: 0.5 }}
//             >
//               {stats.expiredConsents}
//             </Typography>
//           </Box>

//           <Box sx={{ textAlign: "center" }}>
//             <Typography
//               variant="caption"
//               sx={{ color: maroon, fontWeight: 600, fontSize: "0.8rem" }}
//             >
//               ACTIVE CONSENTS
//             </Typography>
//             <Typography
//               variant="h4"
//               sx={{ color: maroon, fontWeight: 700, mt: 0.5 }}
//             >
//               {stats.activeConsents}
//             </Typography>
//           </Box>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// // Study Consent Forms Card Component
// const StudyConsentFormsCard = ({
//   studies,
//   onViewConsentForm,
//   onManageForms,
// }) => {
//   return (
//     <Card
//       elevation={1}
//       sx={{
//         height: "100%",
//         boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
//         borderRadius: 0,
//       }}
//     >
//       <CardContent
//         sx={{ height: "100%", display: "flex", flexDirection: "column" }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "flex-start",
//             mb: 2,
//           }}
//         >
//           <Typography variant="h6" sx={{ fontWeight: 700, color: maroon }}>
//             Consent Form Management
//           </Typography>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//             <Button
//               variant="text"
//               endIcon={<ChevronRightIcon />}
//               onClick={onManageForms}
//               sx={{
//                 color: "#666",
//                 fontWeight: 600,
//                 fontSize: "0.75rem",
//                 py: 0.5,
//                 px: 1.5,
//                 "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)", color: "#333" },
//               }}
//             >
//               MANAGE FORMS
//             </Button>
//           </Box>
//         </Box>
//         <Divider sx={{ mb: 2 }} />

//         <Box sx={{ flexGrow: 1 }}>
//           <List
//             sx={{
//               p: 0,
//               display: "grid",
//               gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
//               columnGap: 10,
//               rowGap: 1,
//             }}
//           >
//             {studies.map((study, index) => (
//               <ListItem
//                 key={index}
//                 sx={{
//                   px: 0,
//                   py: 0.75,
//                   flexDirection: "column",
//                   alignItems: "stretch",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     mb: 1,
//                   }}
//                 >
//                   <Typography
//                     variant="body1"
//                     sx={{ fontWeight: 500, color: "#333", fontSize: "0.9rem" }}
//                   >
//                     {study.displayName}
//                   </Typography>
//                 </Box>
//                 <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
//                   {study.languages.map((lang, langIndex) => (
//                     <Button
//                       key={langIndex}
//                       variant="contained"
//                       startIcon={<FolderIcon />}
//                       onClick={() => onViewConsentForm(lang)}
//                       sx={{
//                         backgroundColor: maroon,
//                         fontWeight: 600,
//                         fontSize: "0.875rem",
//                         py: 0.5,
//                         px: 2,
//                         "&:hover": { backgroundColor: "#4a0000" },
//                       }}
//                     >
//                       CONSENT FORM ({lang.language.toUpperCase()})
//                     </Button>
//                   ))}
//                 </Box>
//               </ListItem>
//             ))}
//           </List>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// const AdminDashboard = () => {
//   const navigate = useNavigate();
//   const [stats, setStats] = useState({
//     totalPatients: 0,
//     totalSamplesCollected: 0,
//     totalAliquotsProcessed: 0,
//     totalAliquotsShipped: 0,
//   });
//   const [studies, setStudies] = useState([]);
//   const [userProfile, setUserProfile] = useState(null);
//   const [consentStats, setConsentStats] = useState({
//     reviewsNeeded: 0,
//     expiredConsents: 0,
//     activeConsents: 0,
//   });
//   const [consentFormStudies, setConsentFormStudies] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
  
//   const [studyDialogOpen, setStudyDialogOpen] = useState(false);
//   const [editingStudyId, setEditingStudyId] = useState(null);

//   const loadData = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         // Fetch all dashboard data in parallel
//         const [
//           userProfileData,
//           adminStats,
//           activeStudies,
//           enrollmentStats,
//           biospecimenStats,
//           consentStatsData,
//           consentFormGroupsData,
//           allStudiesData,
//         ] = await Promise.all([
//           getUserProfile(),
//           fetchAdminStats(),
//           fetchActiveStudies(),
//           fetchEnrollmentStats(),
//           fetchBiospecimenStats(),
//           fetchConsentStats(),
//           fetchConsentFormGroups(),
//           fetchStudies(),
//         ]);

//         const studiesWithConsentCounts = await Promise.all(
//           (activeStudies || []).map(async (study) => {
//             if (!study.irbStudy) {
//               return { ...study, patientCount: 0 };
//             }

//             try {
//               const response = await fetchPatientData({
//                 page: 1,
//                 limit: 1,
//                 irbStudies: [study.irbStudy],
//                 sortBy: "name",
//                 sortOrder: "asc",
//               });

//               return {
//                 ...study,
//                 patientCount: response?.total ?? response?.patients?.length ?? 0,
//               };
//             } catch (error) {
//               console.error("Error loading study consent count:", error);
//               return { ...study, patientCount: 0 };
//             }
//           })
//         );

//         // Update user profile and studies
//         setUserProfile(userProfileData);
//         setStudies(studiesWithConsentCounts);

//         // Merge all stats
//         const mergedStats = {
//           ...adminStats,
//           ...enrollmentStats,
//           ...biospecimenStats,
//         };

//         setStats(mergedStats);

//         // Consent stats
//         setConsentStats(
//           consentStatsData || {
//             reviewsNeeded: 2,
//             expiredConsents: 0,
//             activeConsents: 12,
//           }
//         );

//         const studiesById = new Map(
//           (Array.isArray(allStudiesData) ? allStudiesData : []).map((study) => [
//             study.irbStudy,
//             study,
//           ])
//         );

//         const transformedConsentStudies = (Array.isArray(consentFormGroupsData)
//           ? consentFormGroupsData
//           : [])
//           .map((group) => {
//             const study = group.irbStudy ? studiesById.get(group.irbStudy) : null;
//             const baseName =
//               group.consentName ||
//               study?.studyName ||
//               group.studyDisplayName ||
//               group.irbStudy ||
//               "Consent Form";

//             return {
//               id: `${group.consentName || "general"}-${group.irbStudy || "general"}`,
//               studyId: group.irbStudy || "",
//               studyName: baseName,
//               displayName:
//                 group.consentType === "GENERAL"
//                   ? `${baseName} (General)`
//                   : group.studyDisplayName ||
//                     `${group.irbStudy}: ${study?.studyName || group.irbStudy}`,
//               languages: (group.entries || [])
//                 .map((entry) => ({
//                   language: entry.language || "",
//                   widgetUrl: entry.widgetUrl || "",
//                 }))
//                 .sort((a, b) => a.language.localeCompare(b.language)),
//             };
//           })
//           .sort((a, b) => a.studyName.localeCompare(b.studyName));

//         setConsentFormStudies(transformedConsentStudies);
//       } catch (error) {
//         console.error("Error loading dashboard data:", error);
//         setError(error.message);
//       } finally {
//         setLoading(false);
//       }
//   };

//   useEffect(() => {
//     loadData();
//   }, []);


//   const handleAddStudy = () => {
//     setEditingStudyId(null);
//     setStudyDialogOpen(true);
//   };

//   const handleViewStudyPatients = (studyId) => {
//     if (!studyId) return;
//     const params = new URLSearchParams();
//     params.append("irbStudies", studyId);
//     navigate(`${ADMIN_ROUTES.PATIENT_DATA}?${params.toString()}`);
//   };

//   const handleViewSamples = () => {
//     navigate(ADMIN_ROUTES.SAMPLE_DATA);
//   };

//   const handleOutstandingReviews = () => {
//     navigate(ADMIN_ROUTES.REVIEWS_APPROVALS);
//   };

//   const handleViewConsentForm = (lang) => {
//     if (lang.action === "add") {
//       navigate(ADMIN_ROUTES.CONSENT_FORMS_MANAGEMENT);
//       return;
//     }
//     if (lang.widgetUrl) {
//       window.open(lang.widgetUrl, "_blank", "width=800,height=600");
//     } else {
//       console.error("No widget URL available for this consent form");
//     }
//   };

//   const handleEditStudy = (study) => {
//     setEditingStudyId(study.irbStudy || study.id);
//     setStudyDialogOpen(true);
//   };

//   const handleManageForms = () => {
//     navigate(ADMIN_ROUTES.CONSENT_FORMS_MANAGEMENT);
//   };
//   if (loading) {
//     return (
//       <Box
//         sx={{
//           p: 3,
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           minHeight: "400px",
//           flexDirection: "column",
//         }}
//       >
//         <Box
//           sx={{
//             width: 40,
//             height: 40,
//             border: `4px solid #f3f3f3`,
//             borderTop: `4px solid ${maroon}`,
//             borderRadius: "50%",
//             animation: "spin 1s linear infinite",
//             margin: "0 auto 20px",
//           }}
//         />
//         <Typography variant="h6" sx={{ color: maroon }}>
//           Loading dashboard data...
//         </Typography>
//         <style>{`
//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//         `}</style>
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box sx={{ p: 3, textAlign: "center" }}>
//         <Typography variant="h6" sx={{ color: "#d32f2f", mb: 2 }}>
//           Error loading dashboard
//         </Typography>
//         <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
//           {error}
//         </Typography>
//         <Button
//           variant="contained"
//           onClick={() => window.location.reload()}
//           sx={{
//             backgroundColor: maroon,
//             "&:hover": { backgroundColor: "#4a0000" },
//           }}
//         >
//           Retry
//         </Button>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: 3 }}>
//       {/* Header */}
//       <PageHeader
//         title={
//           <>
//             Welcome Back,{" "}
//             <Box component="span">
//               {userProfile?.firstName || userProfile?.fullName || "Admin"}
//             </Box>
//             !
//           </>
//         }
//       />

//       {/* Dashboard Cards Grid */}
//       <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
//         {/* Full width cards */}
//         <Box sx={{ width: "100%" }}>
//           <ActiveStudiesCard
//             studies={studies}
//             totalPatients={stats.totalPatients}
//             onAddStudy={handleAddStudy}
//             onViewStudyPatients={handleViewStudyPatients}
//             onEditStudy={handleEditStudy}
//           />
//         </Box>
//         <Box sx={{ width: "100%" }}>
//           <BioSpecimenSamplesCard
//             stats={stats}
//             onViewSamples={handleViewSamples}
//           />
//         </Box>
//         <Box sx={{ width: "100%" }}>
//           <ConsentManagementCard
//             stats={consentStats}
//             onOutstandingReviews={handleOutstandingReviews}
//           />
//         </Box>
//         <Box sx={{ width: "100%" }}>
//           <StudyConsentFormsCard
//             studies={consentFormStudies}
//             onViewConsentForm={handleViewConsentForm}
//             onManageForms={handleManageForms}
//           />
//         </Box>
//         <Box sx={{ width: "100%" }}>
//           <SampleTypeManagementCard />
//         </Box>
//         <Box sx={{ width: "100%" }}>
//           <KitTypeManagementCard />
//         </Box>
//         <Box sx={{ width: "100%" }}>
//           <FollowUpTypeManagementCard />
//         </Box>
//       </Box>

//       {/* Add/Edit Study Dialog */}
//       <AddEditStudy 
//         open={studyDialogOpen} 
//         onClose={() => setStudyDialogOpen(false)} 
//         studyId={editingStudyId} 
//         onSaveSuccess={loadData} 
//       />
//     </Box>
//   );
// };

// export default AdminDashboard;
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  Divider,
  ButtonBase,
  Tooltip,
} from "@mui/material";
import {
  Add as AddIcon,
  ChevronRight as ChevronRightIcon,
  Folder as FolderIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { getUserProfile } from "../../utils/auth";
import {
  fetchAdminStats,
  fetchActiveStudies,
  fetchPatientData,
  fetchEnrollmentStats,
  fetchBiospecimenStats,
  fetchConsentStats,
  fetchConsentFormGroups,
  fetchStudies,
} from "../../utils/api";
import "styles/Dashboard.css";
import PageHeader from "../../components/PageHeader";
import { ADMIN_ROUTES } from "../../constants/routes";

import { formatTodayWithWeekday } from "../../utils/formatDateTime";
import FollowUpTypeManagementCard from "./components/FollowUpTypeManagementCard";
import KitTypeManagementCard from "./components/KitTypeManagementCard";
import SampleTypeManagementCard from "./components/SampleTypeManagementCard";
import AddEditStudy from "./AddEditStudy";

const maroon = "#500000";

const cardSx = {
  height: "100%",
  borderRadius: 3,
  boxShadow: "0 2px 16px rgba(80, 0, 0, 0.08)",
  transition: "box-shadow 0.2s ease",
  "&:hover": {
    boxShadow: "0 6px 24px rgba(80, 0, 0, 0.14)",
  },
};

// Active Studies Card Component
const ActiveStudiesCard = ({
  studies,
  totalPatients,
  onAddStudy,
  onViewStudyPatients,
  onEditStudy,
}) => {
  return (
    <Card elevation={0} sx={cardSx}>
      <CardContent
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          pb: "14px !important",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 2,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, color: maroon }}>
            Active Studies
          </Typography>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={onAddStudy}
            sx={{
              color: maroon,
              borderColor: maroon,
              fontWeight: 600,
              fontSize: "0.75rem",
              py: 0.5,
              px: 2,
              borderRadius: "20px",
              "&:hover": {
                backgroundColor: "rgba(80, 0, 0, 0.06)",
                borderColor: maroon,
              },
            }}
          >
            ADD STUDY
          </Button>
        </Box>
        <Divider sx={{ mb: 2 }} />
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "280px minmax(0, 1fr)" },
            gap: 3,
            alignItems: "stretch",
          }}
        >
          <Box
            sx={{
              px: 2,
              py: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 2,
              minHeight: 84,
              textAlign: "center",
            }}
          >
            <Typography
              variant="caption"
              sx={{ color: maroon, fontWeight: 700, fontSize: "0.8rem" }}
            >
              TOTAL PATIENTS ENROLLED
            </Typography>
            <Typography variant="h3" sx={{ color: maroon, fontWeight: 700 }}>
              {totalPatients ?? 0}
            </Typography>
          </Box>
          <Box sx={{ minWidth: 0, pr: { xs: 0, md: 4 } }}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "minmax(0, 1fr) 120px 96px",
                gap: 2,
                pb: 1,
              }}
            >
              <Typography
                variant="caption"
                sx={{ color: "#666", fontWeight: 700 }}
              >
                STUDY
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: "#666", fontWeight: 700, textAlign: "right" }}
              >
                ENROLLED
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: "#666", fontWeight: 700, textAlign: "right" }}
              >
                ACTION
              </Typography>
            </Box>
            <List sx={{ py: 0 }}>
              {studies.map((study, index) => (
                <ListItem
                  key={study.irbStudy || index}
                  sx={{
                    px: 0,
                    py: 0.75,
                    display: "grid",
                    gridTemplateColumns: "minmax(0, 1fr) 120px 96px",
                    gap: 2,
                    borderTop: index === 0 ? "1px solid #eee" : 0,
                    borderBottom:
                      index === studies.length - 1 ? 0 : "1px solid #eee",
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "rgba(80, 0, 0, 0.03)",
                    },
                  }}
                >
                  <Box
                    sx={{ display: "flex", alignItems: "center", minWidth: 0 }}
                  >
                    <ListItemIcon sx={{ minWidth: 20 }}>
                      <Box
                        sx={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          backgroundColor: "#4caf50",
                          border: "2px solid #4caf50",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Box
                          sx={{
                            width: 6,
                            height: 6,
                            borderRadius: "50%",
                            backgroundColor: "white",
                          }}
                        />
                      </Box>
                    </ListItemIcon>
                    <ListItemText
                      primary={study.name}
                      primaryTypographyProps={{
                        fontSize: "0.9rem",
                        fontWeight: 500,
                        noWrap: true,
                      }}
                    />
                  </Box>
                  <ButtonBase
                    onClick={() => onViewStudyPatients(study.irbStudy)}
                    disabled={!study.irbStudy}
                    aria-label={`View participants enrolled for ${study.name}`}
                    sx={{
                      justifySelf: "end",
                      color: maroon,
                      fontWeight: 700,
                      fontSize: "1rem",
                      px: 1,
                      py: 0.25,
                      minWidth: 56,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: 0.25,
                      "&:hover": {
                        textDecoration: "underline",
                      },
                      "&.Mui-disabled": {
                        color: "#999",
                      },
                    }}
                  >
                    {study.patientCount ?? 0}
                    <ChevronRightIcon sx={{ fontSize: 18 }} />
                  </ButtonBase>
                  <Tooltip title="Edit">
                    <IconButton
                      size="small"
                      onClick={() => onEditStudy(study)}
                      sx={{
                        justifySelf: "end",
                        color: maroon,
                        "&:hover": { backgroundColor: "rgba(80, 0, 0, 0.08)" },
                      }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </ListItem>
              ))}
            </List>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

// BioSpecimen Samples Card Component
const BioSpecimenSamplesCard = ({ stats, onViewSamples }) => {
  return (
    <Card elevation={0} sx={cardSx}>
      <CardContent
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          pb: "10px !important",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 2,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, color: maroon }}>
            BioSpecimen Samples
          </Typography>
          <Button
            variant="text"
            endIcon={<ChevronRightIcon />}
            onClick={onViewSamples}
            sx={{
              color: "#666",
              fontWeight: 600,
              fontSize: "0.75rem",
              py: 0.5,
              px: 1.5,
              borderRadius: "20px",
              "&:hover": {
                backgroundColor: "rgba(80, 0, 0, 0.06)",
                color: maroon,
              },
            }}
          >
            VIEW SAMPLE DATA
          </Button>
        </Box>
        <Divider />
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(3, minmax(0, 1fr))",
            },
            gap: 2,
            flexGrow: 1,
            alignItems: "center",
            py: 2,
          }}
        >
          <Box sx={{ textAlign: "center", m: 1 }}>
            <Typography
              variant="caption"
              sx={{ color: maroon, fontWeight: 600, fontSize: "0.8rem" }}
            >
              TOTAL SAMPLES COLLECTED
            </Typography>
            <Typography
              variant="h4"
              sx={{ color: maroon, fontWeight: 700, mt: 0.5 }}
            >
              {stats.totalSamplesCollected}
            </Typography>
          </Box>
          <Box sx={{ textAlign: "center", m: 1 }}>
            <Typography
              variant="caption"
              sx={{ color: maroon, fontWeight: 600, fontSize: "0.8rem" }}
            >
              TOTAL ALIQUOTS PROCESSED
            </Typography>
            <Typography
              variant="h4"
              sx={{ color: maroon, fontWeight: 700, mt: 0.5 }}
            >
              {stats.totalAliquotsProcessed}
            </Typography>
          </Box>
          <Box sx={{ textAlign: "center", m: 1 }}>
            <Typography
              variant="caption"
              sx={{ color: maroon, fontWeight: 600, fontSize: "0.8rem" }}
            >
              TOTAL ALIQUOTS SHIPPED
            </Typography>
            <Typography
              variant="h4"
              sx={{ color: maroon, fontWeight: 700, mt: 0.5 }}
            >
              {stats.totalAliquotsShipped}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

// Consent Management Card Component
const ConsentManagementCard = ({ stats, onOutstandingReviews }) => {
  return (
    <Card elevation={0} sx={cardSx}>
      <CardContent
        sx={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 2,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, color: maroon }}>
            Consent Management
          </Typography>
          <Button
            variant="text"
            endIcon={<ChevronRightIcon />}
            onClick={onOutstandingReviews}
            sx={{
              color: "#666",
              fontWeight: 600,
              fontSize: "0.75rem",
              py: 0.5,
              px: 1.5,
              borderRadius: "20px",
              "&:hover": {
                backgroundColor: "rgba(80, 0, 0, 0.06)",
                color: maroon,
              },
            }}
          >
            OUTSTANDING REVIEWS
          </Button>
        </Box>
        <Divider sx={{ mb: 2 }} />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            flexGrow: 1,
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="caption"
              sx={{ color: maroon, fontWeight: 600, fontSize: "0.8rem" }}
            >
              REVIEWS NEEDED
            </Typography>
            <Typography
              variant="h4"
              sx={{ color: "#d32f2f", fontWeight: 700, mt: 0.5 }}
            >
              {stats.reviewsNeeded}
            </Typography>
          </Box>

          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="caption"
              sx={{ color: maroon, fontWeight: 600, fontSize: "0.8rem" }}
            >
              EXPIRED CONSENTS
            </Typography>
            <Typography
              variant="h4"
              sx={{ color: maroon, fontWeight: 700, mt: 0.5 }}
            >
              {stats.expiredConsents}
            </Typography>
          </Box>

          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="caption"
              sx={{ color: maroon, fontWeight: 600, fontSize: "0.8rem" }}
            >
              ACTIVE CONSENTS
            </Typography>
            <Typography
              variant="h4"
              sx={{ color: maroon, fontWeight: 700, mt: 0.5 }}
            >
              {stats.activeConsents}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

// Study Consent Forms Card Component
const StudyConsentFormsCard = ({
  studies,
  onViewConsentForm,
  onManageForms,
}) => {
  return (
    <Card elevation={0} sx={cardSx}>
      <CardContent
        sx={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 2,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, color: maroon }}>
            Consent Form Management
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Button
              variant="text"
              endIcon={<ChevronRightIcon />}
              onClick={onManageForms}
              sx={{
                color: "#666",
                fontWeight: 600,
                fontSize: "0.75rem",
                py: 0.5,
                px: 1.5,
                borderRadius: "20px",
                "&:hover": {
                  backgroundColor: "rgba(80, 0, 0, 0.06)",
                  color: maroon,
                },
              }}
            >
              MANAGE FORMS
            </Button>
          </Box>
        </Box>
        <Divider sx={{ mb: 2 }} />

        <Box sx={{ flexGrow: 1 }}>
          <List
            sx={{
              p: 0,
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
              columnGap: 10,
              rowGap: 1,
            }}
          >
            {studies.map((study, index) => (
              <ListItem
                key={index}
                sx={{
                  px: 0,
                  py: 0.75,
                  flexDirection: "column",
                  alignItems: "stretch",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 500, color: "#333", fontSize: "0.9rem" }}
                  >
                    {study.displayName}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  {study.languages.map((lang, langIndex) => (
                    <Button
                      key={langIndex}
                      variant="contained"
                      startIcon={<FolderIcon />}
                      onClick={() => onViewConsentForm(lang)}
                      sx={{
                        backgroundColor: maroon,
                        fontWeight: 600,
                        fontSize: "0.875rem",
                        py: 0.5,
                        px: 2,
                        borderRadius: "20px",
                        "&:hover": { backgroundColor: "#4a0000" },
                      }}
                    >
                      CONSENT FORM ({lang.language.toUpperCase()})
                    </Button>
                  ))}
                </Box>
              </ListItem>
            ))}
          </List>
        </Box>
      </CardContent>
    </Card>
  );
};

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    totalPatients: 0,
    totalSamplesCollected: 0,
    totalAliquotsProcessed: 0,
    totalAliquotsShipped: 0,
  });
  const [studies, setStudies] = useState([]);
  const [userProfile, setUserProfile] = useState(null);
  const [consentStats, setConsentStats] = useState({
    reviewsNeeded: 0,
    expiredConsents: 0,
    activeConsents: 0,
  });
  const [consentFormStudies, setConsentFormStudies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [studyDialogOpen, setStudyDialogOpen] = useState(false);
  const [editingStudyId, setEditingStudyId] = useState(null);

  const loadData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch all dashboard data in parallel
        const [
          userProfileData,
          adminStats,
          activeStudies,
          enrollmentStats,
          biospecimenStats,
          consentStatsData,
          consentFormGroupsData,
          allStudiesData,
        ] = await Promise.all([
          getUserProfile(),
          fetchAdminStats(),
          fetchActiveStudies(),
          fetchEnrollmentStats(),
          fetchBiospecimenStats(),
          fetchConsentStats(),
          fetchConsentFormGroups(),
          fetchStudies(),
        ]);

        const studiesWithConsentCounts = await Promise.all(
          (activeStudies || []).map(async (study) => {
            if (!study.irbStudy) {
              return { ...study, patientCount: 0 };
            }

            try {
              const response = await fetchPatientData({
                page: 1,
                limit: 1,
                irbStudies: [study.irbStudy],
                sortBy: "name",
                sortOrder: "asc",
              });

              return {
                ...study,
                patientCount: response?.totalElements ?? response?.content?.length ?? 0,
              };
            } catch (error) {
              console.error("Error loading study consent count:", error);
              return { ...study, patientCount: 0 };
            }
          })
        );

        // Update user profile and studies
        setUserProfile(userProfileData);
        setStudies(studiesWithConsentCounts);

        // Merge all stats
        const mergedStats = {
          ...adminStats,
          ...enrollmentStats,
          ...biospecimenStats,
        };

        setStats(mergedStats);

        // Consent stats
        setConsentStats(
          consentStatsData || {
            reviewsNeeded: 2,
            expiredConsents: 0,
            activeConsents: 12,
          }
        );

        const studiesById = new Map(
          (Array.isArray(allStudiesData) ? allStudiesData : []).map((study) => [
            study.irbStudy,
            study,
          ])
        );

        const transformedConsentStudies = (Array.isArray(consentFormGroupsData)
          ? consentFormGroupsData
          : [])
          .map((group) => {
            const study = group.irbStudy ? studiesById.get(group.irbStudy) : null;
            const baseName =
              group.consentName ||
              study?.studyName ||
              group.studyDisplayName ||
              group.irbStudy ||
              "Consent Form";

            return {
              id: `${group.consentName || "general"}-${group.irbStudy || "general"}`,
              studyId: group.irbStudy || "",
              studyName: baseName,
              displayName:
                group.consentType === "GENERAL"
                  ? `${baseName} (General)`
                  : group.studyDisplayName ||
                    `${group.irbStudy}: ${study?.studyName || group.irbStudy}`,
              languages: (group.entries || [])
                .map((entry) => ({
                  language: entry.language || "",
                  widgetUrl: entry.widgetUrl || "",
                }))
                .sort((a, b) => a.language.localeCompare(b.language)),
            };
          })
          .sort((a, b) => a.studyName.localeCompare(b.studyName));

        setConsentFormStudies(transformedConsentStudies);
      } catch (error) {
        console.error("Error loading dashboard data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
  };

  useEffect(() => {
    loadData();
  }, []);


  const handleAddStudy = () => {
    setEditingStudyId(null);
    setStudyDialogOpen(true);
  };

  const handleViewStudyPatients = (studyId) => {
    if (!studyId) return;
    const params = new URLSearchParams();
    params.append("irbStudies", studyId);
    navigate(`${ADMIN_ROUTES.PATIENT_DATA}?${params.toString()}`);
  };

  const handleViewSamples = () => {
    navigate(ADMIN_ROUTES.SAMPLE_DATA);
  };

  const handleOutstandingReviews = () => {
    navigate(ADMIN_ROUTES.REVIEWS_APPROVALS);
  };

  const handleViewConsentForm = (lang) => {
    if (lang.action === "add") {
      navigate(ADMIN_ROUTES.CONSENT_FORMS_MANAGEMENT);
      return;
    }
    if (lang.widgetUrl) {
      window.open(lang.widgetUrl, "_blank", "width=800,height=600");
    } else {
      console.error("No widget URL available for this consent form");
    }
  };

  const handleEditStudy = (study) => {
    setEditingStudyId(study.irbStudy || study.id);
    setStudyDialogOpen(true);
  };

  const handleManageForms = () => {
    navigate(ADMIN_ROUTES.CONSENT_FORMS_MANAGEMENT);
  };
  if (loading) {
    return (
      <Box
        sx={{
          p: 3,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            border: `4px solid #f3f3f3`,
            borderTop: `4px solid ${maroon}`,
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 20px",
          }}
        />
        <Typography variant="h6" sx={{ color: maroon }}>
          Loading dashboard data...
        </Typography>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="h6" sx={{ color: "#d32f2f", mb: 2 }}>
          Error loading dashboard
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
          {error}
        </Typography>
        <Button
          variant="contained"
          onClick={() => window.location.reload()}
          sx={{
            backgroundColor: maroon,
            borderRadius: "20px",
            "&:hover": { backgroundColor: "#4a0000" },
          }}
        >
          Retry
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <PageHeader
        title={
          <>
            Welcome Back,{" "}
            <Box component="span">
              {userProfile?.firstName || userProfile?.fullName || "Admin"}
            </Box>
            !
          </>
        }
        subtitle={`Today's Date: ${formatTodayWithWeekday()}`}
      />

      {/* Dashboard Cards Grid */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {/* Full width cards */}
        <Box sx={{ width: "100%" }}>
          <ActiveStudiesCard
            studies={studies}
            totalPatients={stats.totalPatients}
            onAddStudy={handleAddStudy}
            onViewStudyPatients={handleViewStudyPatients}
            onEditStudy={handleEditStudy}
          />
        </Box>
        <Box sx={{ width: "100%" }}>
          <BioSpecimenSamplesCard
            stats={stats}
            onViewSamples={handleViewSamples}
          />
        </Box>
        <Box sx={{ width: "100%" }}>
          <ConsentManagementCard
            stats={consentStats}
            onOutstandingReviews={handleOutstandingReviews}
          />
        </Box>
        <Box sx={{ width: "100%" }}>
          <StudyConsentFormsCard
            studies={consentFormStudies}
            onViewConsentForm={handleViewConsentForm}
            onManageForms={handleManageForms}
          />
        </Box>
        <Box sx={{ width: "100%" }}>
          <SampleTypeManagementCard />
        </Box>
        <Box sx={{ width: "100%" }}>
          <KitTypeManagementCard />
        </Box>
      </Box>

      {/* Add/Edit Study Dialog */}
      <AddEditStudy 
        open={studyDialogOpen} 
        onClose={() => setStudyDialogOpen(false)} 
        studyId={editingStudyId} 
        onSaveSuccess={loadData} 
      />
    </Box>
  );
};

export default AdminDashboard;
